<script setup lang="ts">
import type { SelfAssessmentProps, SelfAssessmentLink } from '@core/types'

const props = defineProps<SelfAssessmentProps>()

const links: SelfAssessmentLink[] = [
    { href: '/ansvarligt-spil', text: 'Spil ansvarligt' },
    { href: 'https://www.stopspillet.dk/', text: 'StopSpillet.dk' },
    { href: 'https://www.rofus.nu/', text: 'Udeluk dig via ROFUS.nu' }
]
</script>

<template>
    <UISelfAssessment v-bind="props" :links="links" />
</template>
